import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { fetchTenantPortal } from '@/api/tenantApi'
import { isValidTenantSlugParam, normalizeTenantSlugParam, setTenantSlug } from '@/config/tenant'
import { RecuperarCodigoPage } from './RecuperarCodigoPage'
import styles from './RecuperarCodigoPage.module.css'

/** Entrada por link da empresa: /e/:slug/recuperar-codigo */
export function RecuperarCodigoEntryPage() {
  const { tenantSlug: rawSlug } = useParams<{ tenantSlug: string }>()
  const slug = normalizeTenantSlugParam(decodeURIComponent(rawSlug ?? ''))
  const [ready, setReady] = useState(false)
  const [erro, setErro] = useState('')

  useEffect(() => {
    let cancelled = false
    async function load() {
      if (!isValidTenantSlugParam(slug)) {
        setErro('Link inválido.')
        return
      }
      try {
        await fetchTenantPortal(slug)
        if (!cancelled) {
          setTenantSlug(slug)
          setReady(true)
        }
      } catch {
        if (!cancelled) setErro('Conta não encontrada ou indisponível.')
      }
    }
    load()
    return () => {
      cancelled = true
    }
  }, [slug])

  if (erro) {
    return (
      <main className={`standalone-page ${styles.page}`}>
        <p className={styles.hint}>{erro}</p>
        <p className={styles.footer}>
          <Link to="/">Voltar</Link>
        </p>
      </main>
    )
  }

  if (!ready) {
    return (
      <main className={`standalone-page ${styles.page}`}>
        <p className={styles.hint}>A carregar…</p>
      </main>
    )
  }

  return <RecuperarCodigoPage />
}
